<template>
    <div>
        <vs-popup class="holamundo" icon-close="X" :title="this.title" :active.sync="active">
            <div class="content">
                <section class="section--sidebar-user">
                    <section class="section--content-sidebar section--content-sidebar-full-height">
                        <form method="POST" :action="this.action" accept-charset="UTF-8" enctype="multipart/form-data"  class="workflow-tabs">
                            <input type="hidden" name="_token" :value="csrf">
                            <input v-if="this.editing" type="hidden" name="_method" value="PUT">
                            
                            <div class="tab-content">
                                
                                <div class="row">
                                    <div class="col-12">
                                        <p class="tab-description mt-3 mb-2">Settings {{title}}</p>
                                    </div>
                                </div>
                                
                                
                                <div class="row mb-3">
                                    <div class="col-12 col-md-4">
                                        <div class="form-group">
                                            <label>{{__("forms.Question.title")}}</label>
                                            <input type="text" class="form-control rounded" name="questionBase[name]" :value="this.name">
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-4">
                                        <div class="form-group">
                                            <label>{{__("forms.Question.description")}}</label>
                                            <input type="text" class="form-control rounded" name="questionBase[description]" :value="this.description">
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-4">
                                        <div class="form-group">
                                            <label>{{__("forms.Question.sorting")}}</label>
                                            <input type="number" class="form-control rounded" name="questionBase[sorting]" :value="this.sorting">
                                        </div>
                                    </div>
                                    
                                    <div class="col-12 col-md-4">
                                        <div class="form-group">
                                            <label>Gruppo Obiettivi</label>
                                            <select class="form-control rounded" name="questionSettings[group_id]" v-model="this.goals_group_id" required>
                                                <option>---</option>
                                                <option v-for="(row) in groupGoals" :value="row.id" :key="row.id">
                                                    {{row.name}}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-4">
                                        <div class="form-group">                                
                                            <label>Tipologia di calcolo del risultato</label>
                                            <select class="form-control rounded" name="questionSettings[type_of_calculation]" v-model="this.type_of_calculation" required>                                    
                                                <option v-for="(row) in typesOfCalculations" :value="row.id" :key="row.id">
                                                    {{row.name}}
                                                </option>
                                            </select>
                                        </div>   
                                    </div>
                                </div>  
                                
                                <div class="row mb-3">
                                    <div class="col-12 col-md-4">
                                        <div class="custom-control custom-switch">
                                            <input name="questionSettings[show_weight]" type="checkbox" class="custom-control-input" id="questionSettings[show_weight]" value="1" v-model="show_weight">
                                            <label class="custom-control-label" for="questionSettings[show_weight]">
                                                Mostra pesi
                                            </label>
                                        </div> 
                                    </div>
                                    <div class="col-12 col-md-4">
                                        <div class="custom-control custom-switch">
                                            <input name="questionSettings[show_total_score]" type="checkbox" class="custom-control-input" id="questionSettings[show_total_score]" value="1" v-model="show_total_score">
                                            <label class="custom-control-label" for="questionSettings[show_total_score]">
                                                Mostra Final Score
                                            </label>
                                        </div> 
                                    </div>
                                </div>
                                
                                
                                <div class="row">
                                    <div class="col-12">
                                        <p class="tab-description mt-3 mb-2">Settings rows</p>
                                    </div>
                                </div>
                                
                                <div class="row my-3">
                                    <div class="col-12">
                                        <div class="form-group">
                                            <div class="single--item">
                                                
                                                <div class="single--item-info">
                                                    <h6>Key</h6>
                                                </div>
                                                <div class="single--item-info">
                                                    <h6>Label</h6>
                                                </div>
                                                <div class="single--item-info">
                                                    <h6>Score</h6>
                                                </div>
                                                <div class="single--item-info">
                                                    <h6>Imposta data valutazione</h6>
                                                </div>
                                                <div class="single--item-info">
                                                    <h6>Min. Rating</h6>
                                                </div>
                                                <div class="single--item-info">
                                                    <h6>Max. Rating</h6>
                                                </div>
                                                <div class="single--item-info">
                                                    <h6>Date Goal</h6>
                                                </div>
                                                <div class="single--item-button">
                                                </div>
                                            </div>
                                            <div class="single--item" v-for="(row,index) in rows" :key="index">
                                                
                                                <div class="single--item-info">
                                                    <h6>{{row.id}}</h6>
                                                </div>
                                                <div class="single--item-info">
                                                    <input class="form-control rounded" :name="'questionSettings[rows]['+row.id+'][label]'" :value="row.label">
                                                </div>
                                                <div class="single--item-info pl-2">
                                                    
                                                    <div class="custom-control custom-switch">
                                                        <input :name="'questionSettings[rows]['+row.id+'][score]'" type="checkbox" class="custom-control-input" :id="'questionSettings[rows]['+row.id+'][score]'" value="1" v-model="row.score">
                                                        <label class="custom-control-label" :for="'questionSettings[rows]['+row.id+'][score]'">
                                                        </label>
                                                    </div> 
                                                </div>
                                                <div class="single--item-info pl-2">
                                                    <div class="custom-control custom-switch">
                                                        <input :name="'questionSettings[rows]['+row.id+'][set_date]'" type="checkbox" class="custom-control-input" :id="'questionSettings[rows]['+row.id+'][set_date]'" value="1" v-model="row.set_date">
                                                        <label class="custom-control-label" :for="'questionSettings[rows]['+row.id+'][set_date]'">
                                                        </label>
                                                    </div> 
                                                </div>
                                                <div class="single--item-info">
                                                    <input class="form-control rounded" :name="'questionSettings[rows]['+row.id+'][min_rating]'" type="number" min="0" :value="row.min_rating">
                                                </div>
                                                <div class="single--item-info">
                                                    <input class="form-control rounded" :name="'questionSettings[rows]['+row.id+'][rating]'" type="number" min="0" :value="row.rating">
                                                </div>
                                                <div class="single--item-info">
                                                    <input class="form-control rounded" :name="'questionSettings[rows]['+row.id+'][goal_date]'" type="date"  :value="row.goal_date">
                                                </div>
                                                <div class="single--item-button">
                                                    <button type="button" class="btn btn--only-icon-rounded btn--danger" @click="rmGoalRow(index)"><i class="fas fa-times"></i></button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                                
                                
                                
                                <div class="row mb-3 align-items-end">
                                    <div class="col-12 col-md-4">
                                        <div class="form-group">
                                            <label>Nuova key</label>
                                            <input type="text" class="form-control rounded" v-model="newKey">
                                        </div>
                                    </div>
                                    
                                    <div class="col-12 col-md-4">
                                        <div class="form-group">
                                            <label>Nuova label</label>
                                            <input type="text" class="form-control rounded" v-model="newLabel">
                                        </div>
                                    </div>
                                    
                                    <div class="col-12 col-md-4">
                                        <div class="form-group float-right">
                                            <button class="btn btn--green" type="button" @click="addRowGoal()"> <i class="fa fa-plus-circle"></i>Aggiungi row</button>
                                        </div>
                                    </div>
                                </div> 
                                
                                
                                <div class="row">
                                    <div class="col-12">
                                        <hr>
                                    </div>
                                    <div class="col-12 mt-3 text-right" v-if="can_write">
                                        <button class="btn btn-next" type="submit">{{ __('misc.save') }}</button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </section>                                                           
                </section>
            </div>
        </vs-popup>
    </div>
</template>

<script>
export default {
    
    props: {
        can_write:{
            type:Boolean,
            required:true,
        }
    },
    data () {
        return {
            groupGoals : [],
            rows : [],
            goals_group_id : 0,
            show_weight : 0,
            show_total_score : 0,               
            type_of_calculation: 0,
            typesOfCalculations : [],
            newKey : "",
            newLabel : "",
            //default
            title: "Obiettivi",
            active : false,
            action : "",
            name:"",
            description:"",
            sorting:-1,
            editing : true,
            csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
        }
    },
    methods: {
        addRowGoal(){
            //Check if
            console.log(this.newKey, this.newLabel);
            if ( this.newKey ==='' || this.newLabel ===''){
                alert("You can't insert an empty row");
                return;
            }
            this.rows.push ({id:this.newKey, label : this.newLabel, score: 0, min_rating: 0, rating : 0}) ;
            console.log("added");
        },
        rmGoalRow(index){
            //Delete element
            Vue.delete(this.rows,index);
        },
        toggle(action, item_id, editing, attributes) {
            this.active     = true;
            this.action     = action;
            this.editing    = editing;
            this.lang       = attributes.lang;
            let dataRoute   = decodeURI(attributes.dataRoute);
            if (dataRoute!==undefined) {
                if (dataRoute.indexOf("[id]")>0) {
                    dataRoute = dataRoute.replace("[id]", item_id);
                    
                }
                axios.get(dataRoute)
                .then((response) => {
                    console.log(response.data);
                    this.goals_group_id = response.data.goals_group_id;
                    this.groupGoals = response.data.groupGoals;
                    this.type_of_calculation = response.data.type_of_calculation;
                    this.typesOfCalculations = response.data.typesOfCalculations;
                    this.rows       = response.data.rows;
                    this.show_total_score = response.data.show_total_score;
                    this.show_weight = response.data.show_weight;
                    this.name = response.data.base.name;
                    this.description = response.data.base.description;
                    this.sorting = response.data.base.sorting;
                    this.can_write = app.__vue__.questionPermission(this.can_write,response.data.base.enable);           
                });
            }
        }
        
    }
    
}
</script>

